import { 
  ArrowUpCircleIcon,
  CheckBadgeIcon,
  DocumentDuplicateIcon,
  PaperAirplaneIcon, 
  ShieldCheckIcon, 
  XCircleIcon 
} from "@heroicons/react/24/outline"

import { 
  ArrowUpCircleIcon as ArrowUpCircleIconSolid,
  CheckBadgeIcon as CheckBadgeIconSolid, 
  CheckCircleIcon as CheckCircleIconSolid, 
  PaperAirplaneIcon as PaperAirplaneIconSolid, 
  ShieldCheckIcon as ShieldCheckIconSolid 
} from "@heroicons/react/24/solid"

const columns = {
  student: { id: "student", name: "Student", sortable: false, deselectable: false },
  guardian: { id: "guardian", name: "Guardian", sortable: false, deselectable: false },
  email: { id: "email", name: "Account", sortable: false, deselectable: true },
  emailed_date: { id: "emailed_date", name: "Last Email Sent", sortable: false, deselectable: true },
  icons: { id: "icons", name: "Status Icons", sortable: false, deselectable: false, },
  actions: { id: "actions", name: "Actions", sortable: false, deselectable: false, align: "text-end" },
}

const defaultColumns = [
  "student",
  "guardian",
  "emailed_date",
  "icons",
  "actions",
]

const downloadOptions = [{ key: "xls", name: "Download All XLS" }]

const filters = {
  activated_account: { id: "activated_account", name: "Activated Accounts", filter: { column: "ACTIVATED_AT", operator: "IS_NOT_NULL" }, icon: <CheckCircleIconSolid className="w-6 h-6 mr-2 text-green-500" /> },
  unactivated_account: { id: "unactivated_account", name: "Unactivated Accounts", filter: { column: "ACTIVATED_AT", operator: "IS_NULL" }, icon: <XCircleIcon className="w-6 h-6 mr-2 text-gray-500" /> },
  emailed: { id: "emailed", name: "Email Sent", filter: { column: "LAST_SENT_AT", operator: "IS_NOT_NULL" }, icon: <PaperAirplaneIconSolid className="w-6 h-6 mr-2 text-green-500" /> },
  not_emailed: { id: "not_emailed", name: "Email Not Sent", filter: { column: "LAST_SENT_AT", operator: "IS_NULL" }, icon: <PaperAirplaneIcon className="w-6 h-6 mr-2 text-gray-500" /> },
  legal_guardian: { id: "legal_guardian", name: "Legal Guardian", filter: { column: "LEGAL_GUARDIAN", operator: "EQ", value: true }, icon: <ShieldCheckIconSolid className="w-6 h-6 mr-2 text-green-500" /> },
  not_legal_guardian: { id: "not_legal_guardian", name: "Not Legal Guardian", filter: { column: "LEGAL_GUARDIAN", operator: "EQ", value: false }, icon: <ShieldCheckIcon className="w-6 h-6 mr-2 text-gray-500" /> },
  matched: { id: "matched", name: "Matched", filter: { column: "STATUS", operator: "EQ", value: "MATCHED" }, icon: <CheckBadgeIconSolid className="w-6 h-6 mr-2 text-green-500" /> },
  unmatched: { id: "unmatched", name: "Unmatched", filter: { column: "STATUS", operator: "EQ", value: "UNMATCHED" }, icon: <CheckBadgeIcon className="w-6 h-6 mr-2 text-gray-500" /> },
  priority: { id: "priority1", name: "Priority 1", filter: { column: "CONTACT_SEQUENCE", operator: "EQ", value: 1 }, icon: <ArrowUpCircleIconSolid className="w-6 h-6 mr-2 text-green-500" /> },
  priority_others: { id: "priority_others", name: "Other Priorities", filter: { column: "CONTACT_SEQUENCE", operator: "GT", value: 1 }, icon: <ArrowUpCircleIcon className="w-6 h-6 mr-2 text-gray-500" /> },
  duplicate: { id: "duplicate", name: "Duplicate Invites", filter: { column: "STUDENT_INVITE_COUNT", operator: "GT", value: 1 }, icon: <DocumentDuplicateIcon className="w-6 h-6 mr-2 text-orange-500" /> },
}

export { columns, defaultColumns, downloadOptions, filters }